const isOperaMini = () => {
	const isOperaHigh = navigator.userAgent.includes("OPR/") && navigator.userAgent.includes("Mobile") && !navigator.userAgent.includes("Presto/");
	const isOperaExtreme = navigator.userAgent.includes("Opera Mini/") && navigator.userAgent.includes("Presto/");

	if (isOperaHigh || isOperaExtreme) {
		return true;
	} else {
		return false;
	}
};

export default isOperaMini;
